export default __webpack_public_path__ + "static/media/user-list-on.8cc5729b.svg";